import { render, staticRenderFns } from "./FlgTextInputForm.vue?vue&type=template&id=b6dde59c&scoped=true&"
import script from "./FlgTextInputForm.vue?vue&type=script&lang=js&"
export * from "./FlgTextInputForm.vue?vue&type=script&lang=js&"
import style0 from "./FlgTextInputForm.vue?vue&type=style&index=0&id=b6dde59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dde59c",
  null
  
)

export default component.exports